export type Genre = {
  label: string;
  icon: string;
  queryValue?: string; // APIに送信する値（指定がなければlabelを使用）
};

export type GenreCategory = {
  category: string;
  genres: Genre[];
};

export const GENRE_OPTIONS: GenreCategory[] = [
  {
    category: "発散したい",
    genres: [
      { label: "遊園地/水族館/動物園", icon: "🎡", queryValue: "遊園地/水族館/動物園" },
      { label: "公園", icon: "🌳", queryValue: "公園" },
      { label: "屋内レジャー", icon: "🎤", queryValue: "屋内レジャー" },
      { label: "屋外レジャー", icon: "🏕️", queryValue: "屋外レジャー" }
    ]
  },
  {
    category: "癒されたい",
    genres: [
      { label: "温泉/サウナ", icon: "♨️", queryValue: "温泉/サウナ" },
      { label: "カフェ/スイーツ", icon: "☕", queryValue: "カフェ/スイーツ" },
      { label: "図書館/大型本屋", icon: "📖", queryValue: "図書館/大型本屋" }
    ]
  },
  {
    category: "体感したい",
    genres: [
      { label: "絶景/自然", icon: "😮", queryValue: "絶景/自然" },
      { label: "体験工房", icon: "🐄", queryValue: "体験工房" },
      { label: "科学館/美術館/博物館", icon: "🔭", queryValue: "科学館/博物館/美術館" },
      { label: "城/寺/神社", icon: "🏯", queryValue: "城/寺/神社" },
      { label: "観光その他", icon: "🗼", queryValue: "観光その他" }
    ]
  },
  {
    category: "食べたい",
    genres: [
      { label: "肉系", icon: "🍖", queryValue: "肉系" },
      { label: "海鮮系", icon: "🍣", queryValue: "海鮮系" },
      { label: "麺系", icon: "🍜", queryValue: "麺系" },
      { label: "イタリアン", icon: "🍕", queryValue: "イタリアン" },
      { label: "辛い系", icon: "🌶️", queryValue: "辛い系" },
      { label: "居酒屋・バー", icon: "🍺", queryValue: "居酒屋/バー" }
    ]
  },
  {
    category: "買いたい",
    genres: [
      { label: "ショッピングモール/専門店", icon: "🛍️", queryValue: "ショッピングモール/専門店" }
    ]
  }
];

// フラットなジャンルリスト（APIに送信用）
export const getAllGenres = (): { label: string; icon: string }[] => {
  return GENRE_OPTIONS.flatMap((category) => category.genres);
};
